import * as yup from 'yup';
import labels from '../constants/labels';
import {
  agreementValidation,
  confPasswordValidation,
  contactNameValidation,
  otpStringValidation,
  phoneNoValidation,
  securityPinValidation,
  userNameValidation,
} from './validationSchemaUtil';
import fields from '../constants/fields';
import * as errorMsg from '../constants/validationMessages';
import constraints from '../constants/validationConstraints';

export const otpValidationSchema = yup.object().shape({
  otp: otpStringValidation(labels.OTP),
});

export const accountValidationSchema = yup.object().shape({
  userFullName: contactNameValidation(labels.NAME),
  phoneNumber: phoneNoValidation(labels.CONTACT_PHNO),
});

const validatePasswordWithUserIdentifier = (value, ctx) => {
    const { userIdentifier } = ctx.options.parent;

    if (value && userIdentifier && value.toLowerCase().includes(userIdentifier.toLowerCase())) {
      return ctx.createError({
        message: 'The password must not contain User ID',
      });
    }

    return true;
  };

  const validatePasswordRegex = (value, ctx) => {
    const regex = new RegExp(constraints.CREDENTIAL_PASSWORD_COMMON_REGEX, 'i'); // case insensitive
    if (!regex.test(value)) {
      return ctx.createError({
        message: errorMsg.CREDENTIAL_PASSWORD_COMMON_REGEX_ERR,
      });
    }

    return true;
  };

export const credentialsValidationSchema = yup.object().shape({
  userIdentifier: userNameValidation(labels.USER_ID),
  password: yup
    .string()
    .nullable()
    .max(
      constraints.CREDENTIAL_PASSWORD_MAX,
      errorMsg.MAX_ERROR(labels.PASSWORD, constraints.CREDENTIAL_PASSWORD_MAX)
    )
    .min(
      constraints.CREDENTIAL_PASSWORD_MIN,
      errorMsg.MIN_ERROR(labels.PASSWORD, constraints.CREDENTIAL_PASSWORD_MIN)
    )
    // .matches(
    //   constraints.CREDENTIAL_PASSWORD_REGEX,
    //   errorMsg.CREDENTIAL_PASSWORD_REGEX_ERR
    // )
    // .matches(
    //   constraints.CREDENTIAL_PASSWORD_COMMON_REGEX,
    //   errorMsg.CREDENTIAL_PASSWORD_COMMON_REGEX_ERR
    // )
    .test(
      'Validate Password regex',
      '',
      validatePasswordRegex
    )
    .test(
      'Password should not contain User ID',
      '',
      validatePasswordWithUserIdentifier
    )
    .required(errorMsg.REQUIRED_ERROR(labels.PASSWORD)),
  confirmPassword: confPasswordValidation(fields.password, labels.CONFIRM_PASSWORD),
  securityPin: securityPinValidation(labels.SECURITY_PIN),
  auth: agreementValidation(),
});
